import httpClient from '@/lib/httpClient.js'
import { useMutation } from '@tanstack/react-query'
import { handleFormError } from '@/utils/helpers.js'

export default function useRegisterAccount(setError) {
  const action = async ({
    name,
    lastName,
    email,
    password,
    marketingOptIn = false,
  }) => {
    await httpClient.get('/csrf-cookie')

    const response = await httpClient.post('auth/register', {
      name,
      last_name: lastName,
      email,
      password,
      password_confirmation: password,
      marketing_opt_in: marketingOptIn,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({ error, variables, setError }),
  })

  return {
    registerAccount: mutation.mutateAsync,
    registerAccountStatus: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
